const panels = document.querySelectorAll('.panel');

const removeActiveClasses = () => {
    panels.forEach(panel => {
        panel.classList.remove('active')
    })
}

panels.forEach(panel => {
    panel.addEventListener('mouseenter', () => {
        removeActiveClasses()
        panel.classList.add('active')
    })
    
    // Add click event for expansion
    panel.addEventListener('click', function (event) {
        var checklink = panel.querySelector('a');
        var removelink = panel.classList.contains("no-pointer");
        
        // If there's a link and it's not disabled, navigate to it
        if (checklink && !removelink) {
            // Check if the click target is the link or its child elements
            if (event.target.closest('a') || event.target.closest('.hero-accordian-cta-span')) {
                var plink = panel.querySelector('a').getAttribute('href');
                window.open(plink, "_self");
                return;
            }
        }
        
        // Otherwise, expand the panel
        removeActiveClasses();
        panel.classList.add('active');
    });
})